import { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { gettotalOffers } from "../../store/totaloffer/totaloffAction";
import { Link } from "react-router-dom";
import { baseUrl } from "../../utils/APi";
import { LazyLoadImage } from "react-lazy-load-image-component";
import bg from "../../assets/image/apply-bg.jpg";

const ApplyFor = () => {
  // const dispatch = useDispatch();
  // const lan = useSelector((state) => state.LanSlicer.language);
  // const { offers } = useSelector((state) => state.Offers);

  // useEffect(() => {
  //   if (offers?.length === 0 ) {
  //    const promise= dispatch(gettotalOffers(lan));
  //     return () => {
  //       promise.abort();
  //     };
  //   }
  // }, [lan, dispatch,offers?.length]);

  const [activeIndex, setActiveIndex] = useState(0); // Set the first accordion as active by default

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index); // Toggle between opening and closing
  };

  return (
    <section
      className="apply-now"
      id="apply"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-6 align-self-center">
            <div className="row">
              <div className="col-lg-12">
                <div className="item">
                  <h3>APPLY FOR BACHELOR DEGREE</h3>
                  <p>
                    Although essentially one of many time-wasting student
                    websites, MentalFloss is good for learning interesting facts
                    from around the world, covering topics such as food,
                  </p>
                  <div className="main-button-red">
                    <div className="scroll-to-section">
                      <a href="#contact">Join Us Now!</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="item">
                  <h3>APPLY FOR MASTER DEGREE</h3>
                  <p>
                    Although essentially one of many time-wasting student
                    websites, MentalFloss is good for learning interesting facts
                    from around
                  </p>
                  <div className="main-button-yellow">
                    <div className="scroll-to-section">
                      <a href="#contact">Join Us Now!</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="accordions">
              <article className="accordion">
                <div
                  className={`accordion-head ${
                    activeIndex === 0 ? "is-open" : ""
                  }`}
                  onClick={() => toggleAccordion(0)}
                >
                  <span>About Edu Meeting Webiste</span>
                  <span className="icon">
                    <i
                      className={`icon fa fa-chevron-right ${
                        activeIndex === 0 ? "rotate" : ""
                      }`}
                    ></i>
                  </span>
                </div>
                <div
                  className={`accordion-body ${
                    activeIndex === 0 ? "active" : ""
                  }`}
                >
                  <div className="content">
                    <p>
                      Although essentially one of many time-wasting student
                      websites, MentalFloss is good for learning interesting
                      facts from around the world, covering topics such as food,
                      culture and science.
                      <a
                        rel="nofollow"
                        href="https://www.toocss.com/"
                        target="_blank"
                      >
                        student websites
                      </a>
                      . If you need a working contact form script, please visit{" "}
                      <a href="https://templatemo.com/contact" target="_parent">
                        our contact page
                      </a>{" "}
                      for more info.
                    </p>
                  </div>
                </div>
              </article>
              <article className="accordion">
                <div
                  className={`accordion-head ${
                    activeIndex === 1 ? "is-open" : ""
                  }`}
                  onClick={() => toggleAccordion(1)}
                >
                  <span>time-wasting student websites</span>
                  <span className="icon">
                    <i
                      className={`icon fa fa-chevron-right ${
                        activeIndex === 1 ? "rotate" : ""
                      }`}
                    ></i>
                  </span>
                </div>
                <div
                  className={`accordion-body ${
                    activeIndex === 1 ? "active" : ""
                  }`}
                >
                  <div className="content">
                    <p>
                      Etiam posuere metus orci, vel consectetur elit imperdiet
                      eu. Cras ipsum magna, maximus at semper sit amet, eleifend
                      eget neque. Nunc facilisis quam purus, sed vulputate augue
                      interdum vitae. Aliquam a elit massa.
                      <br />
                      <br />
                      Nulla malesuada elit lacus, ac ultricies massa varius sed.
                      Etiam eu metus eget nibh consequat aliquet. Proin
                      fringilla, quam at euismod porttitor, odio odio tempus
                      ligula, ut feugiat ex erat nec mauris. Donec viverra velit
                      eget lectus sollicitudin tincidunt.
                    </p>
                  </div>
                </div>
              </article>
              <article className="accordion">
                <div
                  className={`accordion-head ${
                    activeIndex === 2 ? "is-open" : ""
                  }`}
                  onClick={() => toggleAccordion(2)}
                >
                  <span>Please tell your friends</span>
                  <span className="icon">
                    <i
                      className={`icon fa fa-chevron-right ${
                        activeIndex === 2 ? "rotate" : ""
                      }`}
                    ></i>
                  </span>
                </div>
                <div
                  className={`accordion-body ${
                    activeIndex === 2 ? "active" : ""
                  }`}
                >
                  <div className="content">
                    <p>
                      Ut vehicula mauris est, sed sodales justo rhoncus eu.
                      Morbi porttitor quam velit, at ullamcorper justo suscipit
                      sit amet. Quisque at suscipit mi, non efficitur velit.
                      <br />
                      <br />
                      Cras et tortor semper, placerat eros sit amet, porta est.
                      Mauris porttitor sapien et quam volutpat luctus. Nullam
                      sodales ipsum ac neque ultricies varius.
                    </p>
                  </div>
                </div>
              </article>
              <article className="accordion last-accordion">
                <div
                  className={`accordion-head ${
                    activeIndex === 3 ? "is-open" : ""
                  }`}
                  onClick={() => toggleAccordion(3)}
                >
                  <span>Share this to your colleagues</span>
                  <span className="icon">
                    <i
                      className={`icon fa fa-chevron-right ${
                        activeIndex === 3 ? "rotate" : ""
                      }`}
                    ></i>
                  </span>
                </div>
                <div
                  className={`accordion-body ${
                    activeIndex === 3 ? "active" : ""
                  }`}
                >
                  <div className="content">
                    <p>
                      Maecenas suscipit enim libero, vel lobortis justo
                      condimentum id. Interdum et malesuada fames ac ante ipsum
                      primis in faucibus.
                      <br />
                      <br />
                      Sed eleifend metus sit amet magna tristique, posuere
                      laoreet arcu semper. Nulla pellentesque ut tortor sit amet
                      maximus. In eu libero ullamcorper, semper nisi quis,
                      convallis nisi.
                    </p>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApplyFor;
